import { render, staticRenderFns } from "./AssociateApp.vue?vue&type=template&id=3efee5f8&scoped=true&"
import script from "./AssociateApp.vue?vue&type=script&lang=js&"
export * from "./AssociateApp.vue?vue&type=script&lang=js&"
import style0 from "./AssociateApp.vue?vue&type=style&index=0&id=3efee5f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efee5f8",
  null
  
)

export default component.exports